'use strict';

var processInclude = require('base/util');
const { imageAndQuickbuyHoverHandler } = require('./product/helper');

$(document).ready(function () {
    processInclude(require('./search/productTileSwatch'));
    imageAndQuickbuyHoverHandler('.pd-recommendations');
});

processInclude(require('./productTile'));
